import React, {VoidFunctionComponent} from "react";
import {ProductFeature} from "@/models/scope/productSheet/ProductFeature";
import {FeatureBlock} from "@/components/responsive/product/layer/features/FeatureBlock";

export const Features: VoidFunctionComponent<{ features: ProductFeature[] }> = ({features}) => {
    const allGroup = features?.map((feature) => feature.group);
    const filteredAllGroup = allGroup?.filter(
        (group, index) => allGroup.indexOf(group) === index,
    );

    return (
        <div className='features'>
            {filteredAllGroup?.map(
                (group, index) =>
                    group === 'Pictos' &&
                    <FeatureBlock features={features.filter((feature) => feature.group === group)} group={group}
                                  key={group + '_' + index.toString()}/>
            )}
            {filteredAllGroup?.map(
                (group, index) =>
                    group !== 'Pictos' &&
                    <FeatureBlock features={features.filter((feature) => feature.group === group)} group={group}
                                  key={group + '_' + index.toString()}/>
            )}
        </div>
    );
};